import { Link } from "wouter";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoImage from "@assets/Fill_The_Trucks_big_FullLogo_Transparent_NoBuffer_1770523528478.png";

interface SignupHeaderProps {
  showBack?: boolean;
  backUrl?: string;
  backLabel?: string;
}

export function SignupHeader({ showBack = true, backUrl = "/", backLabel }: SignupHeaderProps) {
  const isHomeLink = backUrl === "/";
  const displayLabel = backLabel || (isHomeLink ? "Back to Home" : "Go Back");
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur border-b">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-3 hover-elevate rounded-md p-1 -m-1" data-testid="link-signup-logo-home">
          <img src={logoImage} alt="Fill The Trucks" className="h-8" />
        </Link>
        
        <div className="flex items-center gap-2">
          {!isHomeLink && (
            <Link href="/">
              <Button variant="ghost" size="sm" data-testid="button-home">
                <Home className="w-4 h-4 mr-2" />
                Home
              </Button>
            </Link>
          )}
          {showBack && (
            <Link href={backUrl}>
              <Button variant="ghost" size="sm" data-testid="button-back">
                <ArrowLeft className="w-4 h-4 mr-2" />
                {displayLabel}
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
